import React, { Fragment } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { promoverInspector } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck'
import { useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import estilos from './InspectoresFormComponent.module.css'

const InspectoresFormComponent = (props) => {

    const dispatch = useDispatch()
    const [isEnCapacitacion, setIsEnCapacitacion] = React.useState('')
    const inspectorPromover = props.inspectorPromover
    const [initialStateFormik, setInitialStateFormik] = React.useState({
        idinspector: '',
        titulo: '',
        nombre: '',
        apellidos: '',
        celular: '',
        puesto: '',
        tarjeta: '',
        estatus: '',
        laptop: '',
        vehiculo: '',
        tutor: '',
        acreditacion:''
    })


    React.useState(() => {
        if (inspectorPromover !== null) {
            setInitialStateFormik({
                idinspector: inspectorPromover.idinspector,          
                puesto: 'inspector',       
                estatus: 'Acreditado',             
                acreditacion:inspectorPromover.acreditacion
            })
        }
    }, [inspectorPromover])

    return (
        <Fragment>
            <div className='row'>
                <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ${estilos.contenedorBorder}`}>
                    <div className='row'>
                        <h1 className={`${estilos.tituloForm}`}>{
                            inspectorPromover ?
                                "Promover inspector" :
                                ''
                        }</h1>
                    </div>
                    <Formik
                        initialValues={initialStateFormik}
                        validate={values => {
                            const errors = {};
                            return errors;
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            if (inspectorPromover) {
                                console.log(values)
                                const data = { data:{
                                    
                                    idinspector: values.idinspector,                    
                                    estatus: values.estatus,
                                    idcatalogodepuestos:1,                             
                                    acreditacion:values.acreditacion
                                }}
                                dispatch(promoverInspector(data))
                            } 
                            setSubmitting(false);
                            props.onClose()
                        }}
                    >

                        {({ isSubmitting }) => (
                            <Form>
                                <div className={`container ${estilos.contenedorForm}`}>                               
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <label htmlFor="puesto">Puesto:</label><br />
                                            <Field as="select" name="puesto" className='form-control' value={isEnCapacitacion} onChange={e => setIsEnCapacitacion(e.target.value)}>                                              
                                                <option value='inspector'>Inspector</option>                                            
                                            </Field>
                                            <ErrorMessage name="puesto" component="div" className={`${estilos.error}`} /><br />

                                        </div>

                                        <div className='col-md-6'>
                                            <label htmlFor="acreditacion">Número de Acreditación:</label><br />
                                            <Field type="text" name="acreditacion" className='form-control'>
                                            </Field>
                                            <ErrorMessage name="acreditacion" component="div" className={`${estilos.error}`} /><br />
                                        </div>
                                        
                                    </div>
                                    <div className='text-center'>
                                        <button type="submit" disabled={isSubmitting} className='btn btn-lg btn-success'>
                                            {
                                                inspectorPromover ?
                                                    "promover" :
                                                    ""
                                            }
                                        </button>
                                    </div>

                                </div>
                            </Form>
                        )}

                    </Formik>
                </div>
             
            </div>

        </Fragment>
    )
}

export default withRouter(InspectoresFormComponent)